"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMessenger = void 0;
var React = __importStar(require("react"));
var IconMessenger = function (props) { return (React.createElement("svg", __assign({ width: "34px", height: "34px", viewBox: "0 0 34 34" }, props),
    React.createElement("g", { id: "Messenger", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("g", null,
            React.createElement("rect", { id: "Background", fill: "#0084FF", x: 0, y: 0, width: 34, height: 34, rx: 4 }),
            React.createElement("path", { d: "M17.4649786,19.8902212 L15.0405601,17.4194673 C14.8985021,17.2745933 14.6752269,17.2401901 14.4946484,17.3355038 L10.2403959,19.5784777 C10.0783936,19.6638512 9.91948733,19.4608866 10.0454891,19.3298302 L15.0726006,14.1121099 C15.2168906,13.9625831 15.4598941,13.9625831 15.6038961,14.1123919 L18.0274506,16.6305208 C18.1697966,16.7786377 18.3959518,16.8138869 18.5784744,16.7166697 L22.7589978,14.4880069 C22.9210001,14.4017875 23.0807704,14.6050341 22.9544806,14.7364429 L17.9940421,19.8877538 C17.8508321,20.0364347 17.6098446,20.0375627 17.4649786,19.8902212 M17,6 C10.924851,6 6,10.5689126 6,16.2047319 C6,19.4151661 7.59839266,22.2786775 10.0967453,24.1492235 L10.1411568,27.7473951 C10.1433913,27.941753 10.353368,28.0623793 10.5224946,27.9662836 L13.9578168,26.0138291 C14.9239749,26.2712956 15.9446698,26.4093938 17,26.4093938 C23.075149,26.4093938 28,21.8404812 28,16.2047319 C28,10.5689126 23.075149,6 17,6", id: "Fill-1", fill: "#FFFFFF" }))))); };
exports.IconMessenger = IconMessenger;
exports.IconMessenger.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconMessenger;
